// @ts-nocheck

/** Dispatch event on click outside of node */
export function clickOutside(node) {

    const handleClick = event => {
        if (node && !node.contains(event.target) && !event.defaultPrevented) {
            node.dispatchEvent(
                new CustomEvent('click_outside', node)
            )
        }
    }

    clickOutside.__destroy(node);
    clickOutside.__nodes.push({node: node, handler: handleClick});
    document.addEventListener('click', handleClick, true);

    return {
        destroy() {
            clickOutside.__destroy(node);
        }
    }
}


clickOutside.__destroy = function(node) {
    for (let i = 0; i < clickOutside.__nodes.length; i++) {
        if (clickOutside.__nodes[i].node === node) {
            document.removeEventListener('click', clickOutside.__nodes[i].handler, true);
            clickOutside.__nodes.splice(i, 1);
            break;
        }
    }
}


clickOutside.__nodes = [];
